import axios from 'axios'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import Select from 'react-select'

const CONTACT_TYPE_OPTIONS = [
    { value: 'LINK', label: 'קישור' },
    { value: 'EMAIL', label: 'אימייל' },
]

// התמונה הקיימת יכולה להגיע כקישור מלא או כמפתח ב-S3 (כמו במארזים)
const resolveImageUrl = (imageUrl) => {
    if (!imageUrl) return "";
    if (/^https?:\/\//i.test(imageUrl)) return imageUrl;
    return `https://archivebureau.s3.eu-west-3.amazonaws.com/${imageUrl}`;
}

// ה-input מסוג date מקבל yyyy-MM-dd בלבד; אם מגיע תאריך עם שעה, נשאיר רק את החלק של התאריך
const toInputDate = (dateStr) => (dateStr ? String(dateStr).slice(0, 10) : "");

const ModalNewBenefit = ({ handleColse, editData = null, getDepartment }) => {
    const GET_URL = 'admin/qualification/benefits/create'
    const GET_UPDATA = `admin/qualification/benefits/edit/${editData?.id}`
    // קישור שיתוף להטבה (כמו "קישור למארז" במארזים) — מוצג רק בעריכה של הטבה קיימת
    const link = `https://www.ismbonline.org/Mobile/Benefits?benefitId=${editData?.id}`
    const [formData, setFormData] = useState({
        benefitImage: "",
        name: "",
        description: "",
        providerName: "",
        providerEmail: null,
        providerUrl: null,
        startDate: "",
        endDate: "",
        contactType: "LINK",
        visible: true,
        requiresActiveDues: false,
    })

    const [file, setFile] = useState(null)
    const [errors, setErrors] = useState({});
    const [copied, setCopied] = useState(false);

    const handleChange = (selectedOption, name) => {
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption?.value || null,
        }));
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const handleChangetext = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        };
    }

    const handleFileChange = (event) => {
        const fileInput = event.target;
        const file1 = fileInput.files[0];

        if (file1) {
            setFile(file1)
            // נקה את התמונה הקודמת
            setFormData((prevFormData) => ({
                ...prevFormData,
                "benefitImage": null, // נקה קודם
            }));

            const reader = new FileReader();

            reader.onload = (e) => {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    "benefitImage": e.target.result, // עדכן את התמונה החדשה
                }));
            };
            if (errors[fileInput?.name]) {
                setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[fileInput?.name];
                    return newErrors;
                });
            }
            reader.readAsDataURL(file1);
            fileInput.value = '';
        }
    };

    // העתקת קישור השיתוף ללוח (כמו ב-ModalNewCase)
    const handleCopy = () => {
        navigator.clipboard.writeText(link).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // מחיקת ההודעה אחרי 2 שניות
        }).catch(err => console.error("שגיאה בהעתקה:", err));
    };

    const validate = () => {
        const errors = {};
        if (!formData.name) errors.name = "יש להזין שם הטבה";
        if (!formData.description) errors.description = "יש להזין תיאור";
        if (!formData.providerName) errors.providerName = "יש להזין שם נותן ההטבה";
        if (!formData.startDate) errors.startDate = "יש להזין תאריך התחלה";
        if (!formData.endDate) errors.endDate = "יש להזין תאריך סיום";
        if (formData.startDate && formData.endDate && formData.endDate < formData.startDate) errors.endDate = "תאריך הסיום חייב להיות אחרי תאריך ההתחלה";
        if (!formData.contactType) errors.contactType = "יש לבחור סוג יצירת קשר";
        if (formData.contactType === 'LINK' && !formData.providerUrl) errors.providerUrl = "יש להזין קישור";
        if (formData.contactType === 'EMAIL' && !formData.providerEmail) errors.providerEmail = "יש להזין מייל";
        return errors;
    };

    const addNewBenefit = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        let formData1 = new FormData();
        // לפי סוג יצירת הקשר נשלח רק את השדה הרלוונטי: LINK -> providerUrl, EMAIL -> providerEmail
        formData1.append('reqBenefit', JSON.stringify({
            "name": formData?.name,
            "description": formData?.description,
            "providerName": formData?.providerName,
            "providerEmail": formData?.contactType === 'EMAIL' ? (formData?.providerEmail || null) : null,
            "providerUrl": formData?.contactType === 'LINK' ? (formData?.providerUrl || null) : null,
            "startDate": formData?.startDate,
            "endDate": formData?.endDate,
            "contactType": formData?.contactType,
            "visible": formData?.visible,
            "requiresActiveDues": !!formData?.requiresActiveDues,
        }));
        // התמונה נשלחת רק אם נבחר קובץ חדש; בעריכה ללא בחירה התמונה הקיימת נשארת
        if (file) {
            formData1.append('benefitImage', file);
        }
        let response
        if (editData) {
            response = await axios.put(GET_UPDATA, formData1
                ,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
        }
        else {
            response = await axios.post(GET_URL, formData1
                ,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
        }
        if (response?.status == 200) {
            editData ? toast.success("ההטבה עודכנה") : toast.success("ההטבה התווספה");
            getDepartment()
            handleColse()
        }
        else {
            console.log("error add benefit")
        }
    }

    useEffect(() => {
        if (editData) {
            setFormData({
                benefitImage: "",
                name: editData.name || "",
                description: editData.description || "",
                providerName: editData.providerName || "",
                providerEmail: editData.providerEmail || null,
                providerUrl: editData.providerUrl || null,
                startDate: toInputDate(editData.startDate),
                endDate: toInputDate(editData.endDate),
                contactType: editData.contactType || "LINK",
                visible: editData.visible ?? true,
                requiresActiveDues: editData.requiresActiveDues ?? false,
            });
        }
    }, [])

    return (
        <div className=' fixed top-0 bottom-0 right-0 left-0 flex flex-col items-center py-4 w-full min-h-screen drop-shadow-2xl shadow-2xl bg-slate-600/80 overflow-y-auto'>
            <div className='bg-white w-[60%] rounded-lg divide-y-2  divide-slate-500 border-0 border-emerald-50 '>
                <div className='w-full bg-[#0d406b] rounded-t-md flex justify-end border-[#0d406b] border-2'>
                    <button className='p-1 px-2 m-3 border bg-blue-700 hover:bg-blue-500' onClick={() => {
                        handleColse()
                    }} >x</button>
                </div>

                <form className='w-full p-5 flex flex-col  text-center text-sm'>

                    <div className="w-full pt-2 flex justify-end">
                        <input
                            className='border w-1/2 text-right'
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChangetext}
                        />
                        <label htmlFor="name" className='w-[30%] font-semibold'><p className='ml-2'><span className='text-red-600'>*</span>שם הטבה</p></label>
                    </div>
                    {errors.name && <span className="text-red-500 text-sm">{errors.name}</span>}

                    <div className="w-full pt-2 flex justify-end">
                        <textarea
                            className='border w-1/2 text-right'
                            rows={3}
                            id="description"
                            name="description"
                            value={formData.description}
                            onChange={handleChangetext}
                        />
                        <label htmlFor="description" className='w-[30%] font-semibold'><p className='ml-2'><span className='text-red-600'>*</span>תיאור</p></label>
                    </div>
                    {errors.description && <span className="text-red-500 text-sm">{errors.description}</span>}

                    <div className="w-full pt-2 flex justify-end">
                        <input
                            className='border w-1/2 text-right'
                            type="text"
                            id="providerName"
                            name="providerName"
                            value={formData.providerName}
                            onChange={handleChangetext}
                        />
                        <label htmlFor="providerName" className='w-[30%] font-semibold'><p className='ml-2'><span className='text-red-600'>*</span>שם נותן ההטבה</p></label>
                    </div>
                    {errors.providerName && <span className="text-red-500 text-sm">{errors.providerName}</span>}

                    <div className="w-full pt-2 flex justify-end">
                        <input
                            className='border w-1/2 text-right'
                            type="url"
                            id="providerUrl"
                            name="providerUrl"
                            value={formData.providerUrl || ""}
                            onChange={handleChangetext}
                        />
                        <label htmlFor="providerUrl" className='w-[30%] font-semibold'><p className='ml-2'>{formData.contactType === 'LINK' && <span className='text-red-600'>*</span>}קישור</p></label>
                    </div>
                    {errors.providerUrl && <span className="text-red-500 text-sm">{errors.providerUrl}</span>}

                    <div className="w-full pt-2 flex justify-end">
                        <input
                            className='border w-1/2 text-right'
                            type="email"
                            id="providerEmail"
                            name="providerEmail"
                            value={formData.providerEmail || ""}
                            onChange={handleChangetext}
                        />
                        <label htmlFor="providerEmail" className='w-[30%] font-semibold'><p className='ml-2'>{formData.contactType === 'EMAIL' && <span className='text-red-600'>*</span>}מייל</p></label>
                    </div>
                    {errors.providerEmail && <span className="text-red-500 text-sm">{errors.providerEmail}</span>}

                    <div className="w-full pt-2 flex justify-end">
                        <input
                            className='border w-1/2 text-right bg-slate-300'
                            type="date"
                            id="startDate"
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleChangetext}
                        />
                        <label htmlFor="startDate" className='w-[30%] font-semibold'><p className='ml-2'><span className='text-red-600'>*</span>תאריך התחלה</p></label>
                    </div>
                    {errors.startDate && <span className="text-red-500 text-sm">{errors.startDate}</span>}

                    <div className="w-full pt-2 flex justify-end">
                        <input
                            className='border w-1/2 text-right bg-slate-300'
                            type="date"
                            id="endDate"
                            name="endDate"
                            value={formData.endDate}
                            onChange={handleChangetext}
                        />
                        <label htmlFor="endDate" className='w-[30%] font-semibold'><p className='ml-2'><span className='text-red-600'>*</span>תאריך סיום</p></label>
                    </div>
                    {errors.endDate && <span className="text-red-500 text-sm">{errors.endDate}</span>}

                    <div className="w-full pt-2 flex justify-end">
                        <Select
                            className=' w-1/2 border text-right'
                            placeholder="בחר סוג יצירת קשר"
                            isSearchable={false}
                            id="contactType"
                            name="contactType"
                            options={CONTACT_TYPE_OPTIONS}
                            value={CONTACT_TYPE_OPTIONS.find(o => o.value === formData.contactType) || null}
                            onChange={(e) => handleChange(e, 'contactType')}
                            maxMenuHeight={150}
                        />
                        <label htmlFor="contactType" className='w-[30%] font-semibold'><p className='ml-2'><span className='text-red-600'>*</span>סוג יצירת קשר</p></label>
                    </div>
                    {errors.contactType && <span className="text-red-500 text-sm">{errors.contactType}</span>}

                    <div className="w-full pt-2 flex justify-end items-center">
                        <div className='w-1/2 flex justify-end'>
                            <input
                                className='border w-4 h-4'
                                type="checkbox"
                                id="visible"
                                name="visible"
                                checked={formData.visible}
                                onChange={handleChangetext}
                            />
                        </div>
                        <label htmlFor="visible" className='w-[30%] font-semibold'><p className='ml-2'>מוצג</p></label>
                    </div>

                    <div className="w-full pt-2 flex justify-end items-center">
                        <div className='w-1/2 flex justify-end'>
                            <input
                                className='border w-4 h-4'
                                type="checkbox"
                                id="requiresActiveDues"
                                name="requiresActiveDues"
                                checked={formData.requiresActiveDues}
                                onChange={handleChangetext}
                            />
                        </div>
                        <label htmlFor="requiresActiveDues" className='w-[30%] font-semibold'><p className='ml-2'>הטבה לחברים עם דמי חבר פעילים בלבד</p></label>
                    </div>

                    <div className="w-full flex flex-col items-end gap-2 pt-4">
                        <label htmlFor="benefitImage" className="w-[30%] text-center text-sm font-semibold">
                            תמונה של ההטבה (אופציונלי)
                        </label>

                        {formData.benefitImage || editData?.imageUrl ? (
                            <div className="relative w-[200px] h-[200px] flex self-center" >
                                <img
                                    src={formData.benefitImage || resolveImageUrl(editData?.imageUrl)}
                                    alt="תמונה של ההטבה"
                                    className="w-full h-full object-cover rounded-lg border shadow"
                                />
                                <label
                                    htmlFor="benefitImage"
                                    className="absolute bottom-2 right-2 bg-white bg-opacity-80 px-3 py-1 text-sm border border-gray-300 rounded cursor-pointer hover:bg-opacity-100 transition"
                                >
                                    שנה תמונה
                                </label>
                            </div>
                        ) : (
                            <label
                                htmlFor="benefitImage"
                                className="flex items-center justify-center self-center w-1/2 h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 transition"
                            >
                                <span className="text-gray-500 text-sm">לחץ כאן להעלאת תמונה</span>
                            </label>
                        )}

                        <input
                            id="benefitImage"
                            name="benefitImage"
                            type="file"
                            accept="image/png,image/jpeg"
                            onChange={handleFileChange}
                            className="hidden"
                        />
                    </div>
                </form>
                {editData?.id && <div className='grid grid-cols-10 items-center p-2' dir='rtl'>
                    <div className='col-span-3 font-bold text-gray-700'>קישור להטבה</div>
                    <div className='col-span-4 text-center p-2 text-gray-900 border break-all select-all'>{link}</div>
                    <button
                        type="button"
                        onClick={handleCopy}
                        className="col-span-1 bg-blue-500 mr-2 text-white px-2 py-2 rounded hover:bg-blue-600 transition"
                    >
                        {copied ? "📋 הועתק!" : "📋 העתק"}
                    </button>
                </div>}
                <div className='w-full p-2   flex justify-end'>
                    <button className='border bg-green-500 hover:bg-green-300 p-1 px-3' onClick={() => {
                        addNewBenefit()
                    }}>שמור</button>
                    <button className='border bg-slate-700 hover:bg-slate-500 p-1 px-3' onClick={() => {
                        handleColse()
                    }}>בטל</button>
                </div>
            </div>

        </div>
    )
}

export default ModalNewBenefit
